













import { computed, defineComponent } from '@vue/composition-api';
import AudioPlayerProgressBar from './AudioPlayerProgressBar.vue';

export default defineComponent({
  name: 'FullAudioPlayer',
  props: {
    currentTime: { type: Number, default: 0 },
    isPlaying: { type: Boolean, default: false },
    duration: { type: Number, default: 0 },
    title: String,
    artist: String,
  },
  components: {
    AudioPlayerProgressBar,
  },
  setup(props, ctx) {
    const inMin = (time) => {
      const min = Math.floor(time / 60);
      const sec = Math.floor(time % 60);
      const secPadded = `${sec < 10 ? '0' : ''}${sec}`;
      return `${min}:${secPadded}`;
    };
    const currentTimeInMin = computed(() => inMin(props.currentTime));
    const durationInMin = computed(() => inMin(props.duration));
    const togglePlay = () => ctx.emit('audio-player:toggle-play');
    const next = () => ctx.emit('audio-player:next');
    const prev = () => ctx.emit('audio-player:prev');
    const seeked = (val) => ctx.emit('audio-player:set-current-time', val);
    return {
      togglePlay,
      currentTimeInMin,
      durationInMin,
      next,
      prev,
      seeked,
    };
  },
});
